import React, { FunctionComponent, useContext, useEffect } from 'react'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from '../routeTree.gen'
import { AuthContext } from '@strac/react-client-auth'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQueryClient } from '@tanstack/react-query'
import ErrorComponent from './ErrorComponent/ErrorComponent'

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    client: undefined,
    queryClient: undefined,
    authUser: undefined,
    authUserLoading: false,
    setAuthUser: undefined,
    clearAuthUser: undefined
  },
  defaultErrorComponent: ({ error, reset }) => <ErrorComponent error={error} reset={reset} />
})

const Router: FunctionComponent<any> = () => {
  const { setAuthUser, authUser, authUserLoading, clearAuthUser } = useContext(AuthContext) as any
  const client = useFeathersClient()

  const queryClient = useQueryClient()

  useEffect(() => {
    if (!authUser) return
    if (!authUser?.active || authUser?.archive) {
      // If the user is no longer active or is archived, log them out
      client.logout().then(() => {
        setAuthUser(undefined)
        router.navigate({ to: '/login' })
      })
    }
  }, [client, authUser, setAuthUser])

  useEffect(() => {
    const loggerListener = (data: any) => {
      if (authUser.id === data.id) {
        if (!data.active || data.archive) {
          // If the user is no longer active or is archived, log them out
          client.logout().then(() => {
            setAuthUser(undefined)
            router.navigate({ to: '/login' })
          })
        }
        router.invalidate()
        setAuthUser(data)
      }
    }
    client.service('users').on('created', loggerListener)
    client.service('users').on('patched', loggerListener)
    return () => {
      client.service('users').removeListener('created', loggerListener)
      client.service('users').removeListener('patched', loggerListener)
    }
  }, [client, authUser, setAuthUser])

  return (
    <RouterProvider
      router={router}
      context={{
        setAuthUser,
        authUser,
        authUserLoading,
        clearAuthUser,
        client,
        queryClient
      }}
    />
  )
}

export default Router
